import React, { useContext } from 'react'
import { UserContext } from 'shared/users/contexts/UserContext'
import { Tab } from 'features/declaration/form/components/editorTabs'
import DeclarationTransitPartiesTab from 'features/declaration/form/components/transit-parties/TransitPartiesTab'
import { extractCountryFromDepartureOffice } from 'shared/ncts/common/classifier-util'
import DeclarationTab from 'features/declaration/form/components/DeclarationTab'
import EventLog from 'features/declaration/event-log/components/EventLog'
import DeclarationSummaryTab from 'features/declaration/form/components/summary/index'
import DirectoTab, { DirectoTabHandle } from '../../components/DirectoTab'
import { User } from '../../../../../routes/Customer/services/user.service'
import EnsHouseConsignmentsTab from '../house-consignment/components/EnsHouseConsignmentsTab'
import EnsGeneralTab from './EnsGeneralTab'
import { UseTransitOperationFormReturn } from '../../../transit-operation/components/useTransitOperationForm'
import TransitOperationFormTabs from '../../../transit-operation/components/TransitOperationFormTabs'
import { useDeclarationEditorContext } from '../../contexts/DeclarationEditorContext'

export interface DeclarationEditorProps {
  form: UseTransitOperationFormReturn
  activeTab: Tab
  directoTabRef: React.RefObject<DirectoTabHandle>
  interactionsLocked: boolean
}

function EnsDeclarationTabs({
  form,
  activeTab,
  directoTabRef,
  interactionsLocked,
}: Readonly<DeclarationEditorProps>) {
  const { user }: { user: User | undefined } = useContext(UserContext)

  const { declarationData } = useDeclarationEditorContext()
  const { transitOperation, consignment } = declarationData
  const country = extractCountryFromDepartureOffice(transitOperation?.departureCustomsOffice ?? null)

  return (
    <>
      <TransitOperationFormTabs
        activeTab={activeTab}
        form={form}
        generalTab={<EnsGeneralTab />}
        transitPartisTab={<DeclarationTransitPartiesTab />}
      />
      {consignment?.id && (
        <DeclarationTab tab="house-consignments" currentTab={activeTab}>
          <EnsHouseConsignmentsTab
            consignmentId={consignment.id}
            interactionsLocked={interactionsLocked}
          />
        </DeclarationTab>
      )}
      <DeclarationTab tab="summary" currentTab={activeTab}>
        <DeclarationSummaryTab consignmentId={consignment?.id ?? null} />
      </DeclarationTab>
      {user?.role === 'ADMIN' && transitOperation?.id ? (
        <DeclarationTab tab="directo" currentTab={activeTab}>
          <DirectoTab
            transitOperationId={transitOperation.id}
            directoEventId={transitOperation.directoId}
            ref={directoTabRef}
          />
        </DeclarationTab>
      ) : null}
      <DeclarationTab tab="logs" currentTab={activeTab}>
        <EventLog transitOperationId={transitOperation?.id ?? null} country={country} />
      </DeclarationTab>
    </>
  )
}

export default EnsDeclarationTabs
